import { EnergySource } from "./energy-source"

export class History {
    // every round, user buys ? amount of stuff
    // different from inventory because items in inventory can decay over time

    public history: Array<Map<EnergySource, number>>
    constructor() {
        this.history = new Array<Map<EnergySource, number>>()
    }
}
